import { apiClient } from './apiClient';
import {
  NestedStateMachine,
  ExecuteNestedStateMachineRequest,
  ExecuteNestedStateMachineResponse,
} from '../types/process';

export class NestedStateMachineService {
  private static instance: NestedStateMachineService;
  private readonly baseUrl = '/nested-state-machines';

  public static getInstance(): NestedStateMachineService {
    if (!NestedStateMachineService.instance) {
      NestedStateMachineService.instance = new NestedStateMachineService();
    }
    return NestedStateMachineService.instance;
  }

  async getNestedStateMachine(processId: string): Promise<NestedStateMachine> {
    const response = await apiClient.get<NestedStateMachine>(`${this.baseUrl}/${processId}`);
    return response.data;
  }

  async validateNestedStateMachine(processId: string): Promise<string[]> {
    const response = await apiClient.get<{ errors: string[] }>(
      `${this.baseUrl}/${processId}/validate`
    );
    return response.data.errors;
  }

  async executeNestedStateMachine(
    processId: string,
    request: ExecuteNestedStateMachineRequest
  ): Promise<ExecuteNestedStateMachineResponse> {
    const response = await apiClient.post<ExecuteNestedStateMachineResponse>(
      `${this.baseUrl}/${processId}/execute`,
      request
    );
    return response.data;
  }
}
